import { DynamicTabsDirective } from './components/organization/captive-portal/tabs/dynamic-tabs.directive';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HashLocationStrategy, LocationStrategy } from '@angular/common';
import { AppRoutes } from './app.routes';
import 'rxjs/add/operator/toPromise';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { SafeHtmlPipe } from './pipe/safe-html-pipe';

import {
  AccordionModule,
  AutoCompleteModule,
  BreadcrumbModule,
  ButtonModule,
  CalendarModule,
  CarouselModule,
  ChartModule,
  CheckboxModule,
  ChipsModule,
  CodeHighlighterModule,
  ConfirmDialogModule,
  ContextMenuModule,
  DataGridModule,
  DataListModule,
  DataScrollerModule,
  DataTableModule,
  DialogModule,
  DragDropModule,
  DropdownModule,
  EditorModule,
  FieldsetModule,
  FileUploadModule,
  GalleriaModule,
  GMapModule,
  GrowlModule,
  InputMaskModule,
  InputSwitchModule,
  InputTextareaModule,
  InputTextModule,
  LightboxModule,
  ListboxModule,
  MegaMenuModule,
  MenubarModule,
  MenuModule,
  MessagesModule,
  MultiSelectModule,
  OrderListModule,
  OrganizationChartModule,
  OverlayPanelModule,
  PaginatorModule,
  PanelMenuModule,
  PanelModule,
  PasswordModule,
  PickListModule,
  ProgressBarModule,
  RadioButtonModule,
  RatingModule,
  ScheduleModule,
  SelectButtonModule,
  SharedModule,
  SidebarModule,
  SlideMenuModule,
  SliderModule,
  SpinnerModule,
  SplitButtonModule,
  StepsModule,
  TabMenuModule,
  TabViewModule,
  TerminalModule,
  TieredMenuModule,
  ToggleButtonModule,
  ToolbarModule,
  TooltipModule,
  TreeModule,
  TreeTableModule,
} from 'primeng/primeng';
import { ColorPickerModule } from 'ngx-color-picker';
import { AppComponent } from './app.component';
import {
  AppMenuComponent,
  AppSubMenuComponent,
} from './components/main/app.menu.component';
import { AppBreadcrumbComponent } from './app.breadcrumb.component';
import { AppTopBarComponent } from './components/main/app.topbar.component';
import { AppFooterComponent } from './app.footer.component';
import { AppPrivacyComponent } from './app.privacy.component';
import { DashboardComponent } from './components/dashboards/key-user-metrics/key-user-metrics.component';
import { DesignerComponent } from './components/organization/captive-portal/cp-designer/designer.component';
import { TabsComponent } from './components/organization/captive-portal/tabs/tabs.component';
import { TabComponent } from './components/organization/captive-portal/tabs/tab.component';
import { DynamicTemplateComponent } from './components/organization/captive-portal/tabs/dynamic-template.component';

import { BreadcrumbService } from './breadcrumb.service';
import { HttpClientModule } from '@angular/common/http';
import { ShareService } from './services/share.service';
import { CpAddUpdateComponent } from './components/organization/captive-portal/cp-add-update/cp-add-update.component';
import { StyleService } from './services/style.service';
import { HttpService } from './services/http.service';
import { LoginComponent } from './components/login/login.component';
import { MainComponent } from './components/main/main.component';

import { ChartsAndSummaryComponent } from './components/dashboards/charts-and-summary/charts-and-summary.component';
import { SaveTemplateComponent } from './components/organization/captive-portal/shared/save-template/save-template.component';
import { CookieService } from 'ngx-cookie-service';
import { Authentication, Authentication4Login } from './auth/Authentication';

import { AgmCoreModule } from '@agm/core';
import { AgmJsMarkerClustererModule } from '@agm/js-marker-clusterer';
import { LocationSetupComponent } from './components/organization/location-setup/location-setup.component';
import { AnalyticsUsersComponent } from './components/organization/analytics-users/analytics-users.component';
import { SecurityGroupsComponent } from './components/organization/security-groups/security-groups.component';
import { AnalyticsEmailAccountsComponent } from './components/organization/accounts/email-accounts/email-accounts.component';
import { AnalyticsSmsAccountsComponent } from './components/organization/accounts/sms-accounts/sms-accounts.component';
import { AnalyticsPaypalAccountsComponent } from './components/organization/accounts/paypal-accounts/paypal-accounts.component';
import { AnalyticsGoogleAccountsComponent } from './components/organization/accounts/google-accounts/google-accounts.component';
import { AnalyticsPaypalOptionsComponent } from './components/organization/accounts/paypal-options/paypal-options.component';
import { AnalyticsFacebookAccountsComponent } from './components/organization/accounts/facebook-accounts/facebook-accounts.component';
import { AnalyticsTwitterAccountsComponent } from './components/organization/accounts/twitter-accounts/twitter-accounts.component';
import { AnalyticsVouchersComponent } from './components/organization/accounts/vouchers/vouchers.component';
import { AnalyticsMailchimpAccountsComponent } from './components/organization/accounts/mailchimp-accounts/mailchimp-accounts.component';
import { LocalesComponent } from './components/organization/captive-portal/locales/locales.component';
import { ActiveSessionsComponent } from './components/sessions/active-sessions/active-sessions.component';
import { SessionsStatComponent } from './components/sessions/sessions-stat/sessions-stat.component';

import { CountriesComponent } from './components/organization/vocabularies/countries/countries.component';
import { CpCodesComponent } from './components/organization/vocabularies/cp-codes/cp-codes.component';
import { ChangeLogComponent } from './components/organization/change-log/change-log.component';
import { ClientsComponent } from './components/admin/clients/clients.component';
import { SessionSummaryComponent } from './components/dashboards/reporting/session-summary/session-summary.component';
import { LoginHistoryComponent } from './components/organization/login-history/login-history.component';
import { DashboardDataService } from './services/dashboard-data.service';
import { UsersComponent } from './components/users/users.component';
import { SessionsComponent } from './components/usage_statistics/sessions/sessions.component';
import { LoginMethodComponent } from './components/usage_statistics/login-method/login-method.component';
import { DataComponent } from './components/usage_statistics/data/data.component';
import { RedirectStrategiesComponent } from './components/organization/captive-portal/redirect-strategies/redirect-startegies.component';
import { LocationGroupsComponent } from './components/organization/location-groups/location-groups.component';
import { ClientsService } from './services/clients/clients.service';
import { WsService } from './services/websocket/WsService';
import { NotLoggedInUsersComponent } from './components/dashboards/reporting/not-logged-in-users/not-logged-in-users.component';
import { ForgetUserComponent } from './components/admin/forget-user/forget-user.component';
import { QuillModule } from 'ngx-quill/src/quill.module';
import { MessagingStrategiesComponent } from './components/organization/captive-portal/messaging-strategies/messaging-strategies.component';
import { DynamicImagesComponent } from './components/organization/captive-portal/dynamic-images/dynamic-images.component';
import { ImageUploaderComponent } from './components/organization/captive-portal/image-uploader/image-uploader.component';
import { BackgroundUploaderComponent } from './components/organization/captive-portal/background-uploader/background-uploader.component';
import { FontsUploaderComponent } from './components/organization/captive-portal/fonts-uploader/fonts-uploader.component';
import { TermsBuilderComponent } from './components/organization/captive-portal/terms-builder/terms-builder.component';
import { SessionDetailReportComponent } from './components/dashboards/reporting/session-detail-report/session-detail-report.component';
import { SmsAccountingComponent } from './components/dashboards/reporting/sms-accounting/sms-accounting.component';
import { AnalyticsWiredMessengerAccountsComponent } from './components/organization/accounts/wired-messenger-accounts/wired-messenger-accounts.component';
import { RegionsComponent } from './components/organization/regions/regions.component';
import { OptInComponent } from './components/dashboards/reporting/opt-in/opt-in.component';
import {TableModule} from "primeng/table";
import { SentMessagesComponent } from './components/dashboards/reporting/sent-messages/sent-messages.component';


@NgModule({
  imports: [
    BrowserModule,
    FormsModule,
    AppRoutes,
    HttpModule,
    BrowserAnimationsModule,
    AccordionModule,
    AutoCompleteModule,
    BreadcrumbModule,
    ButtonModule,
    CalendarModule,
    CarouselModule,
    ChartModule,
    CheckboxModule,
    ChipsModule,
    CodeHighlighterModule,
    ConfirmDialogModule,
    ColorPickerModule,
    SharedModule,
    ContextMenuModule,
    DataGridModule,
    DataListModule,
    DataScrollerModule,
    DataTableModule,
    DialogModule,
    DragDropModule,
    DropdownModule,
    EditorModule,
    FieldsetModule,
    FileUploadModule,
    GalleriaModule,
    GMapModule,
    GrowlModule,
    InputMaskModule,
    InputSwitchModule,
    InputTextModule,
    InputTextareaModule,
    LightboxModule,
    ListboxModule,
    MegaMenuModule,
    MenuModule,
    MenubarModule,
    MessagesModule,
    MultiSelectModule,
    OrderListModule,
    OrganizationChartModule,
    OverlayPanelModule,
    PaginatorModule,
    PanelModule,
    PanelMenuModule,
    PasswordModule,
    PickListModule,
    ProgressBarModule,
    RadioButtonModule,
    RatingModule,
    ScheduleModule,
    SelectButtonModule,
    SidebarModule,
    SlideMenuModule,
    SliderModule,
    SpinnerModule,
    SplitButtonModule,
    StepsModule,
    TabMenuModule,
    TabViewModule,
    TerminalModule,
    TieredMenuModule,
    ToggleButtonModule,
    ToolbarModule,
    TooltipModule,
    TreeModule,
    TreeTableModule,
    HttpClientModule,
    FormsModule,
    ColorPickerModule,
    QuillModule,
    AgmCoreModule.forRoot({
      apiKey: 'AIzaSyBbeaSKEml6HxpqWjOipNt6yT5mip96vfI',
    }),
    AgmJsMarkerClustererModule,
    ReactiveFormsModule,
    PdfViewerModule,
    TableModule
  ],
  declarations: [
    AppComponent,
    AppMenuComponent,
    AppSubMenuComponent,
    AppBreadcrumbComponent,
    AppTopBarComponent,
    AppFooterComponent,
    AppPrivacyComponent,
    DashboardComponent,
    TabsComponent,
    TabComponent,
    DesignerComponent,
    DynamicTemplateComponent,
    CpAddUpdateComponent,
    DynamicTabsDirective,
    LoginComponent,
    MainComponent,
    ChartsAndSummaryComponent,
    SaveTemplateComponent,
    LocationSetupComponent,
    AnalyticsUsersComponent,
    SecurityGroupsComponent,
    AnalyticsEmailAccountsComponent,
    AnalyticsSmsAccountsComponent,
    AnalyticsPaypalAccountsComponent,
    AnalyticsGoogleAccountsComponent,
    AnalyticsPaypalOptionsComponent,
    AnalyticsFacebookAccountsComponent,
    AnalyticsTwitterAccountsComponent,
    AnalyticsVouchersComponent,
    AnalyticsMailchimpAccountsComponent,
    AnalyticsGoogleAccountsComponent,
    LocalesComponent,
    ActiveSessionsComponent,
    SessionsStatComponent,
    ChangeLogComponent,
    SessionSummaryComponent,
    LoginHistoryComponent,
    CountriesComponent,
    CpCodesComponent,
    ChangeLogComponent,
    ClientsComponent,
    UsersComponent,
    SessionsComponent,
    LoginMethodComponent,
    DataComponent,
    RedirectStrategiesComponent,
    LocationGroupsComponent,
    NotLoggedInUsersComponent,
    ForgetUserComponent,
    MessagingStrategiesComponent,
    DynamicImagesComponent,
    ImageUploaderComponent,
    BackgroundUploaderComponent,
    FontsUploaderComponent,
    TermsBuilderComponent,
    SessionDetailReportComponent,
    SmsAccountingComponent,
    AnalyticsWiredMessengerAccountsComponent,
    RegionsComponent,
    OptInComponent,
    SentMessagesComponent,
    SafeHtmlPipe,
  ],
  providers: [
    { provide: LocationStrategy, useClass: HashLocationStrategy },
    BreadcrumbService,
    ShareService,
    StyleService,
    HttpService,
    CookieService,
    Authentication,
    Authentication4Login,
    DashboardDataService,
    ClientsService,
    WsService,
    LocalesComponent
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}



// WEBPACK FOOTER //
// /home/sgurin/IdeaProjects/cosy/cp-builder/src/app/app.module.ts